import { menuBinding, scopeSelection } from './policySelection'
import { GLOBAL_POLICY_MODES } from './policyDisplay'

const modes = { OFF: '关闭', AUDIT: '仅观察', ENFORCE: '正式拦截', MIXED: '混合模式' }
// 2026-10-27 coder(lq): 保存确认先展示可读的系统/菜单差异，仍保留原始策略供技术复核；不以摘要代替服务端校验。
export function policySummary(scopes, before, after) {
    const lines = []
    if (before.enabled !== after.enabled) lines.push(`权限校验总开关：${before.enabled ? '开启' : '关闭'} → ${after.enabled ? '开启' : '关闭'}`)
    if (before.gatewayMode !== after.gatewayMode) lines.push(`全局安全模式：${GLOBAL_POLICY_MODES[before.gatewayMode]} → ${GLOBAL_POLICY_MODES[after.gatewayMode]}`)
    for (const scope of scopes) {
        const previous = scopeSelection(scope, before), next = scopeSelection(scope, after)
        const names = new Map()
        const visit = (node, trail) => {
            const path = [...trail, node.title]; names.set(node.key, path.join(' / ')); node.children.forEach(child => visit(child, path))
        }
        scope.tree.forEach(node => visit(node, []))
        const changes = scope.keys.filter(key => menuBinding(before, key).mode !== menuBinding(after, key).mode
            || previous.keys.includes(key) !== next.keys.includes(key))
        if (changes.length) {
            lines.push(`${scope.title}：${modes[previous.mode]} → ${modes[next.mode]}；已选菜单 ${previous.keys.length} → ${next.keys.length}`)
            changes.forEach(key => lines.push(`${names.get(key)}：${modes[menuBinding(before, key).mode]} → ${modes[menuBinding(after, key).mode]}${next.keys.includes(key) ? '（已勾选）' : '（未勾选）'}`))
        }
    }
    if (JSON.stringify(before.exemptions) !== JSON.stringify(after.exemptions)) lines.push(`接口豁免：${before.exemptions.length} → ${after.exemptions.length} 项（精确方法及路径见技术明细）`)
    return lines
}
